import { NgModule } from '@angular/core';
import { SafeHtmlPipe } from './SafeHtml.pipe';
// SafeHtmlModule is needed for standalone component
@NgModule({
  imports: [SafeHtmlPipe],
  exports: [SafeHtmlPipe],
  providers: [],
})
export class SafeHtmlModule {}
